export default __webpack_public_path__ + "static/media/blue.3ba951da.svg";